<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<!-- <input class="form-control" type="datetime-local" :value="dataInput" @input="$emit('input', $event.target.value)" /> -->
		<date-picker
			class="datepicker-input form-control-datepicker"
			type="datetime"
			value-type="YYYY-MM-DD HH:mm"
			format="DD/MM/YYYY HH:mm"
			:value="value.model"
			@input="(value) => emitValue('input', value)"
			:disabled="disabled"
		></date-picker>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
import mixinInputModel from './mixinInputModel'
export default {
	mixins: [mixinInputModel]
}
</script>
